export const getCurrentYear = (): number => new Date().getFullYear();
